import {EventEmitter, Injectable} from '@angular/core';
import {environment} from '../../../../../environments/environment';
import {HttpService} from '../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root',
})
export class CentroCustoService {

  constructor(
    private httpService: HttpService,
  ) { }


  cancelaAgendamentoAll(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doPost('/enterprise/cancelTravelPlan/all', data, successHandle, errorHandle);
  }

  cancelaAgendamentoBatch(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doPost('/enterprise/cancelTravelPlan/batch', data, successHandle, errorHandle);
  }

  cancelaAgendamento(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doPost('/enterprise/cancelTravelPlan', data, successHandle, errorHandle);
  }

  buscaCentrosCusto(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doGet('/centrosCusto', data, successHandle, errorHandle);
  }


}

